import request from '../../utils/request';

export const quotationSearchService = {
    //DC列表数据查询
    getQuotationListData: (data) => {
        return request({
            url: '/quotation/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    endQuotation: (data) => {
        return request({
            url: '/quotation/closeQuotation',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    recoveryQuotation: (data) => {
        return request({
            url: '/quotation/recoveryQuotation',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    roundInit: (data) => {
        return request({
            url: '/quotation/roundInit',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    createNewRound: (data) => {
        return request({
            url: '/quotation/createNewRound',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    onExport:(data)=> {
      return request({
          url: `quotation/exportQuotationLineHistoryDetail`,
          data:data,
          method: 'post',
          responseType: 'blob',
          fullResponse: true
      });
    },
}